import Figure from "@hydrologiq/shared/figures/generic/Figure"
import { EnergyUnit, EnergyPeriod } from "@hydrologiq/common/types/energy/consumption"
import { roundToDP, pctChange } from "@hydrologiq/common/helpers/math"
import { energy } from "@hydrologiq/common/transformations/data/energy"
import FigureContent from "@hydrologiq/shared/figures/generic/FigureContent"
import TrendIndicator from "@hydrologiq/shared/figures/generic/TrendIndicator"

export interface EnergyProps {
  quantity: number
  desiredUnit: EnergyUnit
  period: EnergyPeriod | "today" | "yesterday"
  previousQuantity: number
  heading?: string
  dp?: number
  sourceUnit?: EnergyUnit
  loading?: boolean
  error?: string
  comparisonDirect?: boolean
  simple?: boolean
  isPlaceholder?: boolean
  compact?: boolean
}

function Energy({
  quantity,
  desiredUnit,
  period,
  previousQuantity,
  heading = "Energy",
  dp = 2,
  sourceUnit,
  loading,
  error,
  comparisonDirect = false,
  simple = true,
  isPlaceholder,
  compact = true,
}: EnergyProps) {
  let change = 0
  if (desiredUnit && sourceUnit) {
    if (previousQuantity != 0) previousQuantity = energy(sourceUnit, desiredUnit, previousQuantity)
    if (quantity != 0) quantity = energy(sourceUnit, desiredUnit, quantity)
  }
  if (quantity != 0 && previousQuantity != 0 && period != EnergyPeriod.LATEST) {
    change = pctChange(quantity, previousQuantity)
    if (previousQuantity < 0 && quantity > 0) change *= -1
  }
  return (
    <Figure heading={heading} loading={loading} error={error} isPlaceholder={isPlaceholder} compact={compact}>
      <FigureContent.Root compact={compact}>
        <FigureContent.SubText link={<TrendIndicator change={roundToDP(change, 1)} />} compact={compact}>{period === "today" ? "so far today" : period}</FigureContent.SubText>
        <FigureContent.Value compact={compact}>
          {roundToDP(quantity, dp)} {desiredUnit}
        </FigureContent.Value>
      </FigureContent.Root>
    </Figure>
  )
}

export default Energy
